import { useQueryClient } from "@tanstack/react-query";
import { useUpdateActionStatus, ACTION_STATUS } from "@core/features/actions";
import { useDialog } from "@platform/store";
import { QuizDialogContainer } from "@platform/features/programQuiz";

export function ProgramPhasesQuizFormContainer() {
  const queryClient = useQueryClient();

  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const actionId =
    (dialogProps?.userActionId as number | undefined) ??
    (dialogProps?.userPhaseActionId as number | undefined) ??
    0;

  const actionCompleted = dialogProps?.actionCompleted as boolean | undefined;

  const { mutate: updateActionStatus } = useUpdateActionStatus({
    actionId,
    status: ACTION_STATUS.COMPLETED,
    currentStatus: actionCompleted ? ACTION_STATUS.COMPLETED : undefined,
  });

  const isOpen = activeDialog === "quiz";
  const quizId = dialogProps?.quizId as number | undefined;

  const handleClose = () => {
    closeDialog();

    queryClient.invalidateQueries({
      queryKey: ["quiz-response", quizId],
    });
  };

  const handleDone = () => {
    closeDialog();

    updateActionStatus();
  };

  // Only render the container when dialog is open and we have a quiz ID
  if (!isOpen || !quizId) {
    return null;
  }

  return (
    <QuizDialogContainer
      onDone={handleDone}
      onClose={handleClose}
      isOpen={isOpen}
      quizId={quizId}
    />
  );
}

export default ProgramPhasesQuizFormContainer;

